import React, { useMemo } from "react";
import PropTypes from "prop-types";

import useToggle from "../../../../hooks/useToggle";
import DialogWindow from "../../../DialogWindow";
import ContentHeaderSubtitle from "../../../ContentHeaderSubtitle";
import { StyledAnchor, StyledGenericNamesWrapper } from "./_.styled";

const MIN_SUBTITLES_LENGTH = 3;
const hasContentGroups = (additionalMetadata) => {
  const [contentGroup] = additionalMetadata;

  return (
    !!contentGroup &&
    (contentGroup.subTitles.length > MIN_SUBTITLES_LENGTH ||
      contentGroup.subTitles[0]?.content?.length > MIN_SUBTITLES_LENGTH)
  );
};

const renderSubtitles = (subtitles, pageType = "classification") =>
  subtitles.map((subtitle) => (
    <ContentHeaderSubtitle
      key={subtitle.id}
      {...subtitle}
      pageType={pageType}
    />
  ));

const ContentGroups = ({ additionalMetadata }) => {
  const {
    isOpen: isDialogOpen,
    handleOpen: openDialog,
    handleCancel: closeDialog,
  } = useToggle();

  const { genericNamesMetadata, classificationsMetadata } = useMemo(
    () => ({
      genericNamesMetadata: additionalMetadata.slice(0, 1),
      classificationsMetadata: additionalMetadata.slice(1),
    }),
    [additionalMetadata]
  );

  if (!hasContentGroups(additionalMetadata)) {
    return renderSubtitles(additionalMetadata);
  }

  return (
    <>
      <StyledAnchor
        data-testid="view-anchor"
        onClick={(e) => {
          e.preventDefault();
          openDialog();
        }}
      >
        All drug types & trade names
      </StyledAnchor>

      {genericNamesMetadata.map((subtitle) => (
        <StyledGenericNamesWrapper>
          <ContentHeaderSubtitle {...subtitle} />
        </StyledGenericNamesWrapper>
      ))}

      {renderSubtitles(classificationsMetadata)}

      <DialogWindow
        pageType="contentPageModal"
        isOpened={isDialogOpen}
        handleClose={closeDialog}
        windowMessage={renderSubtitles(genericNamesMetadata, "genericNames")}
      />
    </>
  );
};

ContentGroups.propTypes = {
  additionalMetadata: PropTypes.array.isRequired,
};

ContentGroups.displayName = "ContentGroups";
export default ContentGroups;
